<template>
  <v-dialog
    v-model="open"
    max-width="790"
    width="550"
    :persistent="true"
    @keydown.prevent.enter="executeMainAction"
  >
    <v-card class="dialog-box">
      <v-card-title class="headline mb-2">
        {{ $t("CablesPassingDetected") }}
      </v-card-title>

      <v-layout row justify-center style="width: 100%" class="mx-1 my-3">
        <div class="pt-1 pr-2">{{ $t("SplitAt") }}:</div>
        <treeselect
          v-model="cable"
          :options="cablesOptions"
          :load-options="loadCablesOptions"
          class="select-tech-point select-cable-treeselect"
          :clearable="false"
          style="width: 50%;"
        />
      </v-layout>
      <v-layout row justify-center style="width: 100%" class="mx-1 my-3">
        <v-radio-group
          v-model="splitOption"
          row
          v-if="cable && cable !== 'NoAction'"
        >
          <v-radio
            :label="$t('PassThrough')"
            value="pass-through"
            color="accent"
          />
          <v-radio :label="$t('Spliced')" value="spliced" color="accent" />
        </v-radio-group>
      </v-layout>
      <v-card-actions>
        <v-btn
          @click="executeSecondaryAction"
          :ripple="false"
          class="secondary-button mt-3"
          text
        >
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          @click="executeMainAction"
          :ripple="false"
          class="main-button mt-3"
          text
          :disabled="!cable"
          :label="$t('Confirm')"
        >
          {{ $t("Confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main";

export default {
  name: "DialogSplitCablesCreatingClosure",

  props: {
    open: {
      type: Boolean,
      required: true
    },

    tpUuid: {
      type: String
    }
  },

  data() {
    return {
      cable: undefined,
      cablesOptions: null,

      splitOption: "pass-through",

      optionNoAction: {
        id: "NoAction",
        label: this.$i18n.t("NoAction")
      }
    };
  },

  mounted() {
    this.loadCablesOptions();
  },

  watch: {
    cable(value) {
      if (value) {
        if (value.geom) {
          bus.$emit("highlight-join-cable-menu", value.geom);
        } else {
          bus.$emit("remove-highlight-join-cable-menu");
        }
      } else {
        bus.$emit("remove-highlight-join-cable-menu");
      }
    }
  },

  methods: {
    ...mapActions(["fetchCablesPassingInTechPoint"]),

    /**
     * Send an event to the parent to execute the main action.
     */
    executeMainAction() {
      let data = { cable_uuid: this.cable, split: this.splitOption };
      this.$emit("mainAction", data);
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    executeSecondaryAction() {
      this.$emit("secondaryAction");
    },

    async loadCablesOptions() {
      try {
        let cables = [];
        let cablesResponse = await this.fetchCablesPassingInTechPoint(
          this.tpUuid
        );
        for (let cable of cablesResponse) {
          let node = {
            id: cable.cb_uuid,
            label: cable.cb_label ? cable.cb_label : cable.cb_id,
            geom: cable.geom.geojson_geom
          };
          cables.push(node);
        }
        this.cablesOptions = cables;
        this.cablesOptions.push(this.optionNoAction);
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style>
.select-cable-treeselect .vue-treeselect__menu {
  max-height: 100px !important;
}

.select-cable-treeselect .vue-treeselect__control {
  background: #f8f8f8;
}

.select-cable-treeselect {
  height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Dialog/DialogSplitCablesCreatingClosure.vue